import { LinkPreview } from 'components/linkPreview/linkPreview.module';
import { checkIfAnchorTag, linkify } from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';

import './formInput.scss';

export const FormInputTemplate = (model) => {
	const {
		display_name,
		attribute_type,
		attribute_id,
		placeholder,
		includeLabel = true,
		includeInput = true,
		message_id,
		inpClassName = '',
		inputWithSelect = false,
		renderAsTextArea = false,
	} = model;
	const localisedPlaceholder = ENGT_CHAT.get('GENERIC_STRINGS')?.['PLACEHOLDER.ENTER'] || 'Please enter';
	const placeholderVal = placeholder || `${localisedPlaceholder} ${display_name.toLowerCase()}`;

	const msg = typeof display_name === 'string' ? display_name : '';

	const linkifyString = msg && linkify(msg);

	const isAnchorTag = linkifyString && checkIfAnchorTag(linkifyString);

	const getLinkPreview = () => {
		const linkPreview = new LinkPreview({
			msg: linkifyString,
			message_id,
			is_iframe: false,
		});
		return linkPreview.render();
	};

	const renderInputField = renderAsTextArea
		? `<textarea rows="5" cols="35" data-field-role="input" type="${attribute_type}" name="${attribute_id}" id="${attribute_id}" placeholder="${placeholderVal}" 
	class="engt-form-input-text ${inpClassName} engt-form-input-text-area" data-interactive-field style="background-color: ${ENGT_CHAT.get(
				'config.textAreaColor'
		  )}"></textarea>`
		: `<input data-field-role="input" type="${attribute_type}" name="${attribute_id}" id="${attribute_id}" placeholder="${placeholderVal}" 
	class="engt-form-input-text ${inpClassName} engt-form-input-${attribute_id}" data-interactive-field style="background-color: ${ENGT_CHAT.get(
				'config.textAreaColor'
		  )}"/>`;

	/* html */
	const bodyHtml = inputWithSelect
		? `<div class="engt-input-with-select">
				<select-box></select-box>
				<input style="max-height:40px; margin-left: 5px;" data-field-role="input" type="${attribute_type}" name="${attribute_id}" id="${attribute_id}" placeholder="${placeholderVal}" 
				class="engt-form-input-text ${inpClassName} engt-form-input-${attribute_id}" data-interactive-field/>
				</div>`
		: renderInputField;

	/* html */
	const formInputHtml = `
			${includeLabel ? `<span class="engt-form-label">${isAnchorTag ? getLinkPreview() : display_name}</span>` : ''} 
			${includeInput ? `${bodyHtml} <error-msg id="engt-error-${attribute_id}"></error-msg>` : ''} 
			`;
	return formInputHtml;
};
